import React, { FC } from 'react';
import { cn } from '@thingslog/ui-components';
import { CommandState } from '@thingslog/repositories';

const STATE_STYLES: Record<CommandState, { pill: string; dot: string }> = {
  PENDING: { pill: 'bg-amber-50 text-amber-700 ring-amber-200', dot: 'bg-amber-500' },
  SENT: { pill: 'bg-sky-50 text-sky-700 ring-sky-200', dot: 'bg-sky-500' },
  STATUS_OK: { pill: 'bg-emerald-50 text-emerald-700 ring-emerald-200', dot: 'bg-emerald-500' },
  STATUS_NOK: { pill: 'bg-red-50 text-red-700 ring-red-200', dot: 'bg-red-500' },
  TIMEOUT: { pill: 'bg-orange-50 text-orange-700 ring-orange-200', dot: 'bg-orange-500' },
  CANCELED: { pill: 'bg-slate-100 text-slate-600 ring-slate-300', dot: 'bg-slate-400' },
  UNKNOWN: { pill: 'bg-slate-100 text-slate-600 ring-slate-300', dot: 'bg-slate-400' },
};

const FALLBACK_STYLE = STATE_STYLES.UNKNOWN;

const isInFlight = (state: CommandState): boolean => state === 'PENDING';

const CommandStateChip: FC<CommandStateChipProps> = ({
  state,
  label,
  className,
}: CommandStateChipProps) => {
  const style = STATE_STYLES[state] ?? FALLBACK_STYLE;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2 py-0.5',
        'text-[13px] font-medium leading-5 ring-1 ring-inset',
        style.pill,
        className
      )}
    >
      <span
        className={cn(
          'h-1.5 w-1.5 shrink-0 rounded-full',
          style.dot,
          isInFlight(state) && 'motion-safe:animate-pulse'
        )}
      />
      {label}
    </span>
  );
};

interface CommandStateChipProps {
  state: CommandState;
  label: string;
  className?: string;
}

export default CommandStateChip;
